//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get, sync, call } from "vuex-pathify"
import SearchOptionsDialog from './SearchOptionsDialog.vue'

export default {
  computed: {
    show_drawer: sync("app/show_drawer"),
    search: sync("app/search"),
    nombre: get("usuario/nombre"),
  },

  methods: {
    clear: call("app/clear"),

    input(value) {
      this.$router.push({ name: "dashboard" }, () => {});
    },

    openSearchOptions() {
      this.$q.dialog({
        component: SearchOptionsDialog
      })
    }
  },
}
